export function getLabel(assignees) {
  if (assignees.length === 0) {
    return 'Assigned to'
  } else {
    return assignees.map(assignee => assignee.text).join(', ')
  }
}
